import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { TextBuildingServicesPage } from "./text-building-services/text-building-services";
import { TextContactPage } from "./text-contact/text-contact";
import { TextCookiesPage } from "./text-cookies/text-cookies";
import { TextDataProtectPage } from "./text-data-protect/text-data-protect";
import { TextImpressPage } from "./text-impress/text-impress";
import { IonicModule } from "@ionic/angular";
const routes: Routes = [
    { path: 'text-building-services', loadComponent: () =>
      import('./text-building-services/text-building-services').then(m => m.TextBuildingServicesPage)
    },
    { path: 'text-contact', loadComponent: () =>
      import('./text-contact/text-contact').then(m => m.TextContactPage)
    },
    { path: 'text-cookies', loadComponent: () =>
      import('./text-cookies/text-cookies').then(m => m.TextCookiesPage)
    },
    { path: 'text-data-protect', loadComponent: () =>
      import('./text-data-protect/text-data-protect').then(m => m.TextDataProtectPage)
    },
    { path: 'text-impress', loadComponent: () =>
      import('./text-impress/text-impress').then(m => m.TextImpressPage)
    }
  ];
@NgModule({
    declarations: [
      TextBuildingServicesPage,
      TextContactPage,
      TextCookiesPage,
      TextDataProtectPage,
      TextImpressPage

    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        SharedModule,
        IonicModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class TextPagesModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }